/* unplugin-vue-components disabled */import "core-js/modules/es.array.join.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx } from "vue";
var _hoisted_1 = ["flex"];
var _hoisted_2 = ["flex"];
var _hoisted_3 = ["onClick"];
import dayjs from 'dayjs';
import Popup from './Popup.vue';
import { showToast } from 'vant';
import useDatePicker from './hook';
import { EDateType } from '@/interface';
import PikerWeek from './PikerWeek.vue';
import PikerDate from './PikerDate.vue';
import PikerMonth from './PikerMonth.vue';
import isToday from 'dayjs/plugin/isToday';
import weekday from 'dayjs/plugin/weekday';
import updateLocale from 'dayjs/plugin/updateLocale';
import PikerUserDefined from './PikerUserDefined.vue';
import { CHAR, DAYJS_FORMAT, DAYJS_LOCALE_NAME } from '@/config/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'Screen',
  props: {
    active: {}
  },
  emits: ["confirm-screen"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    dayjs.extend(weekday);
    dayjs.extend(isToday);
    dayjs.extend(updateLocale);
    dayjs.updateLocale(DAYJS_LOCALE_NAME.ZHCN, {
      weekStart: 1 // 设置周的第一天是 “周一”。（ weekStart 默认是 7，周日。）
    });
    var props = __props;
    var _toRefs = toRefs(props),
      active = _toRefs.active;
    var _useDatePicker = useDatePicker(),
      minYear = _useDatePicker.minYear,
      spacer = _useDatePicker.spacer,
      titleTabs = _useDatePicker.titleTabs,
      isCurrentUnit = _useDatePicker.isCurrentUnit,
      rangeErrorNext = _useDatePicker.rangeErrorNext,
      rangeErrorPrev = _useDatePicker.rangeErrorPrev;
    var emit = __emit;
    var show = ref(false);
    // const keywords = ref('2024/11/06 00:00:00');
    var timeType = ref('startTime');
    var center = ref('main:center cross:center');
    var dateData = reactive({
      endTime: dayjs().endOf('day'),
      startTime: dayjs().startOf('day')
    });
    var isDate = computed(function () {
      return _.eq(active.value, EDateType.day);
    });
    var isWeek = computed(function () {
      return _.eq(active.value, EDateType.week);
    });
    var isMonth = computed(function () {
      return _.eq(active.value, EDateType.month);
    });
    var isYear = computed(function () {
      return _.eq(active.value, EDateType.year);
    });
    var isCustom = computed(function () {
      return _.eq(active.value, EDateType.custom);
    });
    var columnsType = computed(function () {
      if (_.eq(active.value, EDateType.month)) {
        return ['year', 'month'];
      } else if (_.eq(active.value, EDateType.year)) {
        return ['year'];
      } else return _.stubArray();
    });
    var box = computed(function () {
      return isCustom.value ? 'mean' : 'justify';
    });
    var dateText = computed(function () {
      var str = _.stubString();
      var endTime = dateData.endTime,
        startTime = dateData.startTime;
      switch (active.value) {
        case EDateType.day:
          {
            str = startTime.format(DAYJS_FORMAT.YYYYMMDD_SLASH);
            break;
          }
        case EDateType.week:
          {
            str = _.join([startTime.format(DAYJS_FORMAT.YYYYMMDD_SLASH), spacer(CHAR.TILDE), endTime.format(DAYJS_FORMAT.YYYYMMDD_SLASH)], CHAR.NUL);
            break;
          }
        case EDateType.month:
          {
            str = startTime.format(DAYJS_FORMAT.YYYYMM_SLASH);
            break;
          }
        case EDateType.year:
          {
            str = startTime.format(DAYJS_FORMAT.YYYY);
            break;
          }
        case EDateType.custom:
          {
            str = _.join([startTime.format(DAYJS_FORMAT.YYYYMMDD_HHMMSS_SLASH), spacer(CHAR.TILDE), endTime.format(DAYJS_FORMAT.YYYYMMDD_HHMMSS_SLASH)], CHAR.NUL);
            break;
          }
        default:
          {
            str = '日期类型错误';
          }
      }
      return str;
    });
    var keywords = computed(function () {
      if (show.value) return dateData[timeType.value].format(DAYJS_FORMAT.YYYYMMDD_HHMMSS_SLASH);
      return _.stubString();
    });
    watch(active, dateInit, {
      immediate: true
    });
    function dateInit() {
      switch (active.value) {
        case EDateType.day:
          {
            assignInit();
            break;
          }
        case EDateType.week:
          {
            assignInit('week');
            break;
          }
        case EDateType.month:
          {
            assignInit('month');
            break;
          }
        case EDateType.year:
          {
            assignInit('year');
            break;
          }
        case EDateType.custom:
          {
            assignInit();
            break;
          }
        default:
          {
            showToast('日期类型错误');
          }
      }
      emit('confirm-screen', dateData);
    }
    function assignInit() {
      var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'day';
      dateData.startTime = dayjs().startOf(unit);
      dateData.endTime = dayjs();
    }
    function confirmCalendar(value) {
      dateData.startTime = value;
      dateData.endTime = value.endOf('day');
      emit('confirm-screen', dateData);
    }
    function confirmWeek(option) {
      var selected = option.selectedOptions[0];
      dateData.startTime = selected.startTime;
      dateData.endTime = selected.endTime;
      emit('confirm-screen', dateData);
    }
    function confirmMonth(data) {
      var option = data.option,
        unit = data.unit;
      var YYYY_MM = _.join(option.selectedValues, CHAR.DASH);
      dateData.startTime = dayjs(YYYY_MM);
      dateData.endTime = dateData.startTime.endOf(unit);
      emit('confirm-screen', dateData);
    }
    function confirmUserDefined(params) {
      var options = params.options,
        timeType = params.timeType;
      var YYYY_MM_DD = _.join(options[0].selectedValues, CHAR.DASH);
      var HH_MM_SS = _.join(options[1].selectedValues, CHAR.COLON_EN);
      var YYYY_MM_DD_HH_MM_SS = _.join([YYYY_MM_DD, HH_MM_SS], CHAR.SPACE);
      dateData[timeType] = dayjs(YYYY_MM_DD_HH_MM_SS);
      emit('confirm-screen', dateData);
    }
    // 进步器
    function stepByStep(step) {
      var start = dateData.startTime.clone();
      if (isOutRange(step, start)) return;
      switch (active.value) {
        case EDateType.day:
          {
            stepDate(step, start);
            break;
          }
        case EDateType.week:
          {
            stepWeek(step, start);
            break;
          }
        case EDateType.month:
          {
            stepByUnit(step, start, 'month');
            break;
          }
        case EDateType.year:
          {
            stepByUnit(step, start, 'year');
            break;
          }
        case EDateType.custom:
          {
            showToast('自定义无此功能');
            break;
          }
        default:
          {
            showToast('日期类型错误');
          }
      }
      emit('confirm-screen', dateData);
    }
    function stepDate(step, start) {
      if (_.eq(step, 'prev')) {
        dateData.startTime = start.subtract(1, 'day');
        dateData.endTime = dateData.startTime.endOf('day');
      } else if (_.eq(step, 'next')) {
        dateData.startTime = start.add(1, 'day');
        var presetEnd = dateData.startTime.endOf('day');
        dateData.endTime = presetEnd.isToday() ? dayjs() : presetEnd;
      } else {
        showToast('步进器类型错误');
      }
    }
    function stepWeek(step, start) {
      if (_.eq(step, 'prev')) {
        dateData.startTime = start.weekday(-7);
        dateData.endTime = dateData.startTime.endOf('week');
      } else if (_.eq(step, 'next')) {
        dateData.startTime = start.weekday(7);
        var presetEnd = dateData.startTime.endOf('week');
        dateData.endTime = isCurrentUnit(presetEnd, 'week') ? dayjs() : presetEnd;
      } else {
        showToast('步进器类型错误');
      }
    }
    function stepByUnit(step, start, unit) {
      if (_.eq(step, 'prev')) {
        dateData.startTime = start.subtract(1, unit).startOf(unit);
        dateData.endTime = dateData.startTime.endOf(unit);
      } else if (_.eq(step, 'next')) {
        dateData.startTime = start.add(1, unit).startOf(unit);
        var presetEnd = dateData.startTime.endOf(unit);
        dateData.endTime = isCurrentUnit(presetEnd, unit) ? dayjs() : presetEnd;
      } else {
        showToast('步进器类型错误');
      }
    }
    function showPicker() {
      show.value = true;
    }
    function showCusPicker(type) {
      timeType.value = type;
    }
    function isOutRange(step, start) {
      if (isDate.value && _.eq(step, 'prev')) return false;
      var result = true;
      var presetEnd = dayjs();
      var message = rangeErrorNext.value;
      if (_.eq(step, 'prev')) {
        switch (active.value) {
          case EDateType.day:
            {
              console.log('nothing...');
              break;
            }
          case EDateType.week:
            {
              var presetStart = start.weekday(-7);
              if (_.gt(minYear.value, presetStart.year())) {
                message = rangeErrorPrev.value;
              } else {
                result = false;
              }
              break;
            }
          case EDateType.month:
            {
              var _presetStart = start.subtract(1, 'month');
              if (_.gt(minYear.value, _presetStart.year())) {
                message = rangeErrorPrev.value;
              } else {
                result = false;
              }
              break;
            }
          case EDateType.year:
            {
              var _presetStart2 = start.subtract(1, 'year');
              if (_.gt(minYear.value, _presetStart2.year())) {
                message = rangeErrorPrev.value;
              } else {
                result = false;
              }
              break;
            }
          case EDateType.custom:
            {
              message = '自定义无此功能';
              break;
            }
          default:
            {
              message = '日期类型错误';
            }
        }
      } else if (_.eq(step, 'next')) {
        switch (active.value) {
          case EDateType.day:
            {
              var _presetStart3 = start.add(1, 'day');
              presetEnd = _presetStart3.endOf('day');
              if (presetEnd.isToday()) {
                result = false;
              } else {
                result = presetEnd.isAfter(dayjs());
              }
              break;
            }
          case EDateType.week:
            {
              var _presetStart4 = start.weekday(7);
              presetEnd = _presetStart4.endOf('week');
              if (isCurrentUnit(presetEnd, 'week')) {
                result = false;
              } else {
                result = presetEnd.isAfter(dayjs());
              }
              break;
            }
          case EDateType.month:
            {
              var _presetStart5 = start.add(1, 'month').startOf('month');
              presetEnd = _presetStart5.endOf('month');
              if (isCurrentUnit(presetEnd, 'month')) {
                result = false;
              } else {
                result = presetEnd.isAfter(dayjs());
              }
              break;
            }
          case EDateType.year:
            {
              var _presetStart6 = start.add(1, 'year').startOf('year');
              presetEnd = _presetStart6.endOf('year');
              if (isCurrentUnit(presetEnd, 'year')) {
                result = false;
              } else {
                result = presetEnd.isAfter(dayjs());
              }
              break;
            }
          case EDateType.custom:
            {
              message = '自定义无此功能';
              break;
            }
          default:
            {
              message = '日期类型错误';
            }
        }
      } else {
        showToast('步进器类型错误');
      }
      result && showToast(message);
      return result;
    }
    return function (_ctx, _cache) {
      var _component_van_button = _resolveComponent("van-button");
      var _component_van_highlight = _resolveComponent("van-highlight");
      var _component_van_empty = _resolveComponent("van-empty");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        flex: "box:".concat(_unref(box)),
        class: "date-picker-trigger"
      }, [!_unref(isCustom) ? (_openBlock(), _createBlock(_component_van_button, {
        key: 0,
        size: "small",
        icon: "arrow-left",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return stepByStep('prev');
        }),
        class: "stepper stepper-prev"
      })) : _createCommentVNode("", true), _createElementVNode("div", {
        flex: _unref(center),
        class: _normalizeClass(["date-screen", {
          full: _unref(isCustom)
        }]),
        onClick: showPicker
      }, [_createVNode(_component_van_highlight, {
        keywords: _unref(keywords),
        "source-string": _unref(dateText)
      }, null, 8, ["keywords", "source-string"]), _unref(isCustom) ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_unref(titleTabs), function (value, key) {
        return _openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass(["mask", "mask-".concat(key)]),
          onClick: function onClick($event) {
            return showCusPicker(key);
          }
        }, null, 10, _hoisted_3);
      }), 128)) : _createCommentVNode("", true)], 10, _hoisted_2), !_unref(isCustom) ? (_openBlock(), _createBlock(_component_van_button, {
        key: 1,
        size: "small",
        icon: "arrow",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return stepByStep('next');
        }),
        class: "stepper stepper-next"
      })) : _createCommentVNode("", true)], 8, _hoisted_1), _unref(isDate) ? (_openBlock(), _createBlock(PikerDate, {
        key: 0,
        modelValue: _unref(show),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _isRef(show) ? show.value = $event : null;
        }),
        data: _unref(dateData),
        onConfirmCalendar: confirmCalendar
      }, null, 8, ["modelValue", "data"])) : _unref(isWeek) ? (_openBlock(), _createBlock(PikerWeek, {
        key: 1,
        modelValue: _unref(show),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _isRef(show) ? show.value = $event : null;
        }),
        data: _unref(dateData),
        onConfirmWeek: confirmWeek
      }, null, 8, ["modelValue", "data"])) : _unref(isMonth) || _unref(isYear) ? (_openBlock(), _createBlock(PikerMonth, {
        key: 2,
        modelValue: _unref(show),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return _isRef(show) ? show.value = $event : null;
        }),
        data: _unref(dateData),
        active: _unref(active),
        columnsType: _unref(columnsType),
        onConfirmMonth: confirmMonth
      }, null, 8, ["modelValue", "data", "active", "columnsType"])) : _unref(isCustom) ? (_openBlock(), _createBlock(PikerUserDefined, {
        key: 3,
        modelValue: _unref(show),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return _isRef(show) ? show.value = $event : null;
        }),
        data: _unref(dateData),
        timeType: _unref(timeType),
        onConfirmUserDefined: confirmUserDefined
      }, null, 8, ["modelValue", "data", "timeType"])) : (_openBlock(), _createBlock(Popup, {
        key: 4,
        modelValue: _unref(show),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return _isRef(show) ? show.value = $event : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_empty, {
            description: "交互出错"
          })];
        }),
        _: 1
      }, 8, ["modelValue"]))], 64);
    };
  }
});